import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumbs, Button, Typography } from "@mui/material";
import SeparatorIcon from "components/Icons/SeparatorIcon";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";

const SettingBreadCrumbComponent = ({ breadcrumbs, onBreadcrumbClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("BreadCrumb location=======>",location);
  
  const isRestricted = location?.state?.isRestricted || false;

  // console.log("location===.>>.>>",location);
  

  const { syncSubPageCount, search } = useSettingContext();
  const { filterChangeCount, displayCount, filterChangeDesignCount, searchSuffix, searchResultCount , setScrollToBottomTrigger } = useGlobalContext();

  const handleClick = (breadcrumb) => {
    // console.log("Breaddddd",breadcrumb);
    
    let state = { ...location.state, name: [...location?.state?.name, breadcrumb.name], subName: "" };
    // console.log("Statetttt",state);
    
    const pathnames = breadcrumb.path.split("/").filter((x) => x);
    if (breadcrumb.name === "Set") {
      onBreadcrumbClick(breadcrumb);
    }

    switch (pathnames[0]) {
      case "Catalog": {
        if (pathnames.length === 1) {
          state.view = false;
          state.edit = false;
        } else if (pathnames.length === 2) {
          state.edit = false;
          state.view = true;
        } else {
          state.subName = "Edit";
        }
        break;
      }
      default: {
        break;
      }
    }

    setScrollToBottomTrigger(false)

    navigate(breadcrumb.path, { state });
  };

  return (
    <Breadcrumbs aria-label="breadcrumb" separator={<SeparatorIcon />}>
      {breadcrumbs.map((breadcrumb, index) => (
        <span key={index}>
          {index === breadcrumbs.length - 1 ? (
            <Typography color="textPrimary" sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400", fontSize: "24px", cursor: "default" }}>
              {/* {breadcrumb.name} {syncSubPageCount ? ` - ${syncSubPageCount}` : ""} */}
              {/* {breadcrumb.name} {displayCount && `${filterChangeCount && search !== "" ? ` (Search results: ${filterChangeCount})` : ""}`} */}
              {breadcrumb.name} {displayCount && <>{filterChangeCount > 0 && ` - ${filterChangeCount}${filterChangeDesignCount > 0 ? ` (${filterChangeDesignCount} ${searchSuffix})` : ""}`}</>}
              {searchResultCount > 0 && search && ` (Search results: ${searchResultCount})`}
            </Typography>
          ) : (
            <Typography
              color="textPrimary"
              sx={{ fontFamily: "Poppins, sans-serif", fontWeight: "400", fontSize: "24px", color: "inherit", cursor: "pointer" }}
              onClick={!isRestricted ? () => handleClick(breadcrumb, index) : null}
            >
              {breadcrumb.name}
            </Typography>
          )}
        </span>
      ))}
    </Breadcrumbs>
  );
};

export default SettingBreadCrumbComponent;
